import { toast } from "react-toastify";
import Icon from 'components/icon';

export function successAlert(message: string): void {
  toast.success(<>
    <Icon name="alert-success" />
    <div>{message}</div>
  </>);
};

export function errorAlert(message: string): void {
  toast.error(<>
    <Icon name="alert-error" />
    <div>{message}</div>
  </>);
};
